import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import {config} from "../../../../environments/config";
import {Socios} from "../../_model/socios/socios";
import {Observable, Subject} from "rxjs";
import { SocioEmpresa } from 'app/main/_model/socios/socioEmpresa';
import { DatePipe } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class SociosService {
    private clientes: Socios[];
    private clientes$ = new Subject<Socios[]>();
    constructor(private http: HttpClient
    ) {
    }

    getSocios(token) {
        const params = new HttpParams()
            .set('token', token);
        return this.http.post<any>(`${config.apiUrl}/socio`, params)
            .toPromise()
            .then(res => <Socios[]>res.list)
            .then(data => {
                return data;
            });
    }

    getSocio(token) {
        const params = new HttpParams()
            .set('token', token);
        return this.http.post<any>(`${config.apiUrl}/socio`, params)
            .toPromise()
            .then(res => <Socios>res.list)
            .then(data => {
                return data;
            });
    }


    getClientes$(): Observable<Socios[]> {
        return this.clientes$.asObservable();
    }

    agregarCliente(cliente: Socios) {
        this.clientes.push(cliente);
        this.clientes$.next(this.clientes);
    }

    
    getSocioEmpresa(token) {
        const params = new HttpParams()
            .set('token', token);
        return this.http.post<any>(`${config.apiUrl}/socio/empresa`, params)
            .toPromise()
            .then(res => <SocioEmpresa>res.list)
            .then(data => {
                return data;
            });
    }

    updateSocio(token: string, codigo:string, socio: any){
        const body = {
            token: [token],
            data: [
                {
                    codSocio: codigo,
                    apeSocio: socio.ape,
                    nomSocio: socio.nom,
                    stsCivil: socio.stsCivil,
                    // fecNacimiento: socio.fecNac,
                    codPaisNac: socio.paisNac,
                    codProvinciaNac: socio.provNac, 
                    codCantonNac: socio.cantonNac,
                    codParroquiaNac: socio.parrNac,
                    codPais: socio.paisDom, 
                    codProvincia: socio.provDom,
                    codCanton: socio.cantonDom,
                    codParroquia: socio.parrDom,

                    dirDom: socio.dirDom,
                    dir2Dom: socio.dirRef,
                    telDom: socio.telf,
                    telCelular: socio.celular,
                    dirCorreo: socio.email,

                    dirTrabajo: socio.dirTrab,
                    txtLugarTrabajo: socio.lugarTrab,
                    telTrabajo: socio.telTrab,
                }
            ]
          };
        return this.http.post<any>(`${config.apiUrl}/socio/edit`, body)
            .toPromise()
            .then(data => {
                return data;
            });
    }
}
